export default {
  paddingHorizontal: '15px',
  contentMaxWidth: '1200px',
  sidebarWidth: '280px',
  headerHeight: '140px',
  radius: {
    small: '4px',
    medium: '8px',
    large: '12px',
  },
};
